@import '../../../styles/vars.css';

.root {
  box-sizing: border-box;
  line-height: 48px;
  list-style: none;
  color: #757575;
  font-family: var(--font-family);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size);
}

.colorPrimary {
  color: #f7a707;
}

.colorInherit {
  color: inherit;
}

.gutters {
  padding-left: 16px;
  padding-right: 16px;
}

.inset {
  padding-left: 72px;
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: inherit;
}
